var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.sid === 'amseu')?_c('footer',{staticClass:"cabinet-footer",attrs:{"aria-label":"Fußbereich"}},[_c('b-container',{staticClass:"cabinet-footer__inner"},[_c('amseu-footer-bottom')],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }